import * as annuitantHealthRecordsActions from './../actions/health-records.actions';
import { AnnuitantDoctor } from 'src/app/model/ngrx/health-records.model';

export type Actions = annuitantHealthRecordsActions.HealthRecordActions;

const initialState: AnnuitantDoctor = {
    partyType: null,
    organisationName: null,
    addressline1: null,
    addressline2: null,
    addressline3: null,
    addressline4: null,
    emailAddress: null,
    contactNumber: null,
    title: null,
    forename: null,
    middleName: null,
    surname: null,
    thirdName: null,
    postcode: '',
    annReportViewReqInd: '',
    countryCode: null,
    ukAddressIndicator: null
};


export function healthRecordsReducer(state: AnnuitantDoctor[] = [initialState], action: Actions) {
    switch (action.type) {
        case annuitantHealthRecordsActions.ADD_HEALTH_RECORDS:
            return [...state, action.payload];
        case annuitantHealthRecordsActions.REMOVE_HEALTH_RECORDS:
            state = [];
            return state;

        default:
            return state;
    }
}
